<template>
  <div >
    <table>
      <tbody>
      <tr>
        <td>Date</td>
        <td>{{ reportDesc.date }}</td>
      </tr>

      <tr>
        <td>Provider</td>
        <td class="text-capitalize">
          {{ providerFullName }}
        </td>
      </tr>

      <!--<tr>-->
        <!--<td>NPI</td>-->
        <!--<td>{{ reportDesc.npi }}</td>-->
      <!--</tr>-->

      <tr>
        <td>Specialties</td>
        <td>
          <ul>
            <li v-for="(specialty, index) in reportDesc.provider.specialties" :key="index">
              {{ specialty.name }}
            </li>
          </ul>
        </td>
      </tr>

      <tr>
        <td>Document type</td>
        <td>{{ reportDesc.documentType }}</td>
      </tr>

      <tr v-if="reportDesc.procedure">
        <td>Procedure</td>
        <td>{{ reportDesc.procedure }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'report-desc',
  props: {
    reportDesc: Object
  },
  computed: {
    providerFullName: function () {
      const p = this.reportDesc.provider;
      const parts = [];
      if (p.firstName) parts.push(p.firstName.toLowerCase());
      if (p.middleName) parts.push(p.middleName);
      if (p.lastName) parts.push(p.lastName.toLowerCase());
      if (parts.length) return parts.join(' ');
      return p.fullDesc || p.npi || '';
    },
  },
  beforeDestroy() {
    // delete this.reportDesc;
    delete this.providerFullName;
  }
}
</script>

<style scoped lang="scss">
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  table {
    font-size: 0.95em;
  }
  tr:nth-child(odd) {
    background-color: #d4d0d0;
  }
  td {
    padding: 0.5em;
  }

</style>